export default "__VITE_ASSET__DuR$K1rT__"